module.exports = __webpack_public_path__ + "static/lyricordLogo.7ce62de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lyricordLogo.png
// module id = ./src/images/lyricordLogo.png
// module chunks = 168707334958949